import { useState, useEffect } from "react";
import { buscarInfoUsuarioByCotaUsuario } from "../../../services/buscarInfoUsuarioByCotaUsuarioService";
import { buscarInfoUsuarioByInteresseId } from "../../../services/buscarInfoUsuarioByInteresseId";

export const useBuscarInfoInteresseUser = (
  interesseId: number,
  isModalOpen: boolean
) => {
  const [infoUser, setInfoUser] = useState<any>();
  const [isLoading, setIsLoading] = useState(false);
  

  useEffect(() => {
    const fetch = async () => {
      if (!isModalOpen || !interesseId) {
        setIsLoading(false);
        return;
      }
      setIsLoading(true);
      try {
        const data = await buscarInfoUsuarioByInteresseId(interesseId);
        setInfoUser(data);
      } catch (error) {
        console.error("Erro ao buscar info do usuario:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetch();
  }, [isModalOpen, interesseId]);

  return { infoUser, isLoading };
};
